const onlyNumbersRegexp = /^\d+$/;

const onlyUkrString = /^[ а-щА-ЩЬьЮюЯяЇїІіЄєҐґ'`]+$/;

export { onlyNumbersRegexp, onlyUkrString };
